export default "__VITE_ASSET__C3lirW5m__"